module.exports = __webpack_public_path__ + "img/balloon_red.580492b3.svg";